export default "__VITE_ASSET__Cc7MW4pl__"